import { Validator } from '@vista-digital/validator';
import { defaultMemberPhotoUploaderAssets, memberPhotoUploaderAssetsValidator } from './assets';
import { defaultMemberPhotoUploaderDisplayText, memberPhotoUploaderDisplayTextValidator } from './display-text';
/**
 * Default props for the Member Photo Uploader component.
 */
export const defaultMemberPhotoUploaderProps = {
    displayText: defaultMemberPhotoUploaderDisplayText,
    assets: defaultMemberPhotoUploaderAssets
};
export const memberPhotoUploaderPropsValidator = Validator.object({
    displayText: memberPhotoUploaderDisplayTextValidator,
    assets: memberPhotoUploaderAssetsValidator
});
